const APISERVER = process.env.REACT_APP_API
const STATICSERVER = process.env.REACT_APP_STATIC


export const price_endpoint =  `${process.env.REACT_APP_API}/plans/`
export const email_verification_code_send_endpoint = `${process.env.REACT_APP_API}/registrations/email_verification_code/send`
export const email_verification_code_verify_endpoint = `${process.env.REACT_APP_API}/registrations/email_verification_code/verify`
export const registration_endpoint =  `${process.env.REACT_APP_API}/registrations/`
export const contact_us_endpoint =  `${process.env.REACT_APP_API}/contact/send`
